import { render } from "./userProtocol.vue?vue&type=template&id=50cfc2fc"
import script from "./userProtocol.vue?vue&type=script&lang=js"
export * from "./userProtocol.vue?vue&type=script&lang=js"

import "./userProtocol.vue?vue&type=style&index=0&id=50cfc2fc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__